<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as CONTACT_ADDRESS_TYPES } from './store'

import ThuxListMixin from '../../../../components/thux-list/ThuxListMixin'
import { hasPerm } from '@/components/PermissionHelper'

import ContactAddressTable from './ContactAddressTable'
import ContactAddressEdit from './ContactAddressEdit.vue'

export default {
  name: 'ContactAddressList',
  props: ['cntId'],
  mixins: [ThuxListMixin],
  components: {
    'component-table': ContactAddressTable,
    'component-edit': ContactAddressEdit
  },
  data () {
    return {
      title: this.$t('Addresses'),
      rolePerm: ['organization_contactaddress_list'],
      actionEnablePermission: ['organization_contactaddress_enable'],
      actionDisablePermission: ['organization_contactaddress_disable'],
      showHeader: false,
      showCommonFilters: false,
      searchFields: []
    }
  },
  computed: {
    ...mapGetters({
      ...CONTACT_ADDRESS_TYPES.GENERIC.organization.contactaddress.LIST.GETTERS
    }),
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('organization_contactaddress_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: CONTACT_ADDRESS_TYPES.GENERIC.organization.contactaddress.LIST.MUTATIONS.setSelectedList,
      setSelectAll: CONTACT_ADDRESS_TYPES.GENERIC.organization.contactaddress.LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...CONTACT_ADDRESS_TYPES.GENERIC.organization.contactaddress.LIST.ACTIONS
    }),
    getComponentList () {
      this.setFilters({ filter__contact__id: this.cntId })
    },
    openEditForm (id) {
      this.$set(this.editParams, 'cntId', this.cntId)
      if (id) {
        this.$set(this.editParams, 'addressId', id)
      } else {
        this.$set(this.editParams, 'addressId', undefined)
      }
      this.$set(this, 'componentId', id)
      this.$set(this, 'showEditForm', true)
      this.$set(this, 'showDetailForm', false)
    }
  }
}
</script>
